<template>
  <section
    id="o-footer-content"
    class="title-section">
    <div class="title">
      {{ footerConfig.titleSection.title }}
    </div>
    <div class="socials">
      <span
        v-for="(social, i) in footerConfig.titleSection.rs"
        :key="i">
        <a
          v-tealium:click="{
            track_page: 'home',
            track_zone: 'footer',
            track_nom: social.name,
            track_cible: getLink(social.linkRef)
          }"
          :href="getLink(social.linkRef)"
          :aria-label="social.label"
          :class="`social-${social.name}`"
          :data-wptv="`footer-lien-${social.name}`"
          target="blank">
          <wptv-icon
            :title="social.name"
            :name="social.name"
            width="45px"
            height="45px" />
        </a>
      </span>
    </div>
  </section>
</template>

<script>
import footerConfig from '../Footer.config'
import { WptvIcon } from '../../icon'
import _get from 'lodash/get'
export default {
  name: 'FooterTitle',
  components: {
    WptvIcon
  },
  data () {
    return {
      footerConfig
    }
  },
  methods: {
    getLink (linkRef) {
      return _get(this.$config, linkRef)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/abstracts/variables';
@import '../../../scss/abstracts/mixins';

.title-section {
  max-width: 1440px;
  margin: auto;
  text-align: center;
  align-items: center;
  @include mediaQueries('text-align', (small: 'left'));
  padding-top: 21px;
  @include mediaQueries('padding-top', (small: 18px));
  @include mediaQueries('display', (small: 'flex'));

  .title {
    font-size: 22px;
    @include mediaQueries('font-size', (large: 26px));
    line-height: 26px;
    font-weight: 700;
    display: block;
    @include mediaQueries('display', (small: 'inline-block'));
    @include mediaQueries('vertical-align', (small: 'middle'));
    margin-bottom: 25px;
    @include mediaQueries('margin-bottom', (small: 0));
    color: $white;
  }

  .socials {
    @include mediaQueries('display', (small: 'inline-block'));
    @include mediaQueries('margin-left', (small: 10px, medium: 15px));
    > span {
      padding: 7.5px;
    }
    > span:last-child {
      padding-right: 0;
    }
    > span:first-child {
      padding-left: 0;
    }

    a {
      display: inline-flex;
      color: $white;
      height: 45px;
      width: 45px;
      border: 2px solid $white;
      border-radius: 23px;
      justify-content: center;
      align-items: center;

      &:before {
        font-size: 24px;
      }

      &.social-twitter {
        img {
          padding: 8px;
        }
        &:hover {
          background-color: #55acee;
          border-color: #55acee;
        }
      }
      &.social-facebook {
        img {
          padding: 0 14px;
        }
        &:hover {
          background-color: #45619d;
          border-color: #45619d;
        }
      }
    }
  }

}
</style>
